// UnauthorizedMessage.jsx
import { Button } from 'antd';
import { FrownOutlined } from '@ant-design/icons';
import styles from './UnauthorizedMessage.module.scss';
import PropTypes from 'prop-types';

const UnauthorizedMessage = () => {
    const onRetry = () => {
        window.location.reload();
    };
    
    return (
        <div className={`${styles['unauthorized-container']} full-height`}>
            <FrownOutlined className={styles.icon} />
            <div className={styles.message}>Accès Refusé</div>
            <div className={styles.description}>
                Vous n&apos;avez pas les autorisations nécessaires pour accéder à cette page.
            </div>
            <Button type="primary" className={styles.button} onClick={onRetry}>
                Réessayer
            </Button>
        </div>
    );
}

export default UnauthorizedMessage;


UnauthorizedMessage.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    onRetry: PropTypes.func,
};